const TAB_KEY = 'workingHours'
export default {
  name: 'workingHours',

  computed: {
    workingHoursCreateConfig () {
      return {
        title: this.$t('people/person.working_hours'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.workingHoursComponent
          }
        ]
      }
    }
  }
}
